'use strict';

var ACC;

ACC.storedetail = {
    _autoload: [['initStoreDetailsPage', $('.page-storeDetailsPage').length]],

    // Populate on the fly for cached items such as multiple use jQuery look-ups.
    _cache: {
        text: {}, // Populated on the fly to hold JSP text from properties.
        constants: {
            homesense: 'homesense',
            collectionPoint: 'cp'
        }
    },

    map: '',

    initStoreDetailsPage: function() {
        this.cacheStoreDetailsPageElements();
        this.populateBackLinkText();
        ACC.global.addGoogleMapsApi('ACC.storedetail.drawMap');
        ACC.global.referrer('storedetails');
    },

    // Grab anything that will be used for the Store Details Page.
    cacheStoreDetailsPageElements: function() {
        var cache = ACC.storedetail._cache;

        // First add any text detected in JSP in cache.text
        ACC.global.setDataElementText(cache.text, $('#storeDetail'));
    },

    populateBackLinkText: function() {
        var $backlink = $("#breadcrumb [data-node='backlink']");
        var $icon = $backlink.find('i');

        $backlink.text(ACC.storedetail._cache.text.backLinkText);
        $backlink.prepend($icon);
    },

    storeDetailsSmSize: function() {
        var storeDetailWidth = 0;

        $('#storeDetail').height('100%');
        $('.storeDetail-map, .storeDetail-map').height('342');
        ACC.storedetail.drawMapMain(storeDetailWidth);
    },

    storeDetailsLgSize: function() {
        var storeDetailHeight = $('#storeDetail .detailPane').height() + 160,
            storeDetailWidth = Math.round($('#storeDetail .detailPane').width() / 2);

        $('#storeDetail, .storeDetail-map').height(storeDetailHeight);
        ACC.storedetail.drawMapMain(storeDetailWidth);
    },

    drawMap: function() {
        ACC.global.detectWindowResize('storeDetails');
    },

    drawMapMain: function(storeDetailWidth) {
		var SF = ACC.storefinder;
        var $mapCanvas = $('#map_canvas');
        var store = JSON.parse($mapCanvas.attr('data-stores'));
        var centerPoint = new google.maps.LatLng(
            store.latitude,
            store.longitude
        );
        var mapOptions = {
            zoom: 15,
            zoomControl: true,
            panControl: true,
            scrollwheel: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: centerPoint
        };
        var marker;
        var c = SF._constants;
        var storeName;
        var storeType;
        var image;

        delete ACC.storedetail.map; // Make sure it is cleared.
        ACC.storedetail.map = new google.maps.Map($mapCanvas.get(0), mapOptions);
        ACC.storedetail.addStore(store.id, store.latitude, store.longitude, store.name);

        if (storeDetailWidth > 0) {
            ACC.storedetail.map.panBy(-storeDetailWidth, 0);
        }
        // Control map zoom functionality toggling.
        $(document).off('click.storedetailsmap'); // Just in case it is there.
        $(document).on('click.storedetailsmap', function() {
            ACC.storedetail.map.setOptions({
                scrollwheel: false
            });
        });

        $mapCanvas.off('click.storedetailsmap'); // Just in case it is there.
        $mapCanvas.on('click.storedetailsmap', function(e) {
            ACC.storedetail.map.setOptions({
                scrollwheel: true
            });
            e.stopPropagation();
        });

        storeName = $('#storeNameDetail').data('storeName');

        if (storeName !== undefined) {
            storeType = storeName.trim().toLowerCase().split(' ')[0]
        }
        if (storeType === ACC.storedetail._cache.constants.homesense) {
            image = c.FOLDER_IMAGES + 'Hs-logo-pin.png';
        } else if (storeType === ACC.storedetail._cache.constants.collectionPoint) {
            image = c.FOLDER_IMAGES + 'Cp-logo-pin.png';
        } else {
            image = c.FOLDER_IMAGES + 'Tk-logo-pin.png';
        }

        var marker = new google.maps.Marker({
          position: centerPoint,
          icon: {
            size: new google.maps.Size(38, 59),
            url: image
          },
          zIndex: 1
        });

        marker.setMap(ACC.storedetail.map);
        marker.setOpacity(1);
    },

    addStore: function(i, latitude, longitude, name) {
        var map = ACC.storedetail.map;
        var myoverlay = new google.maps.OverlayView();

        myoverlay.draw = function() {
            this.getPanes().markerLayer.id = 'markerLayer';
        };
        myoverlay.setMap(map);
        google.maps.event.trigger(map, 'resize');
    }
};
